import clsx from 'clsx';
import React from 'react';
import { getCardBrandIcon } from 'src/components/Selectors/BuyerSelector/BuyerCard';
import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './PaymentMethodCard.css';

type PaymentMethodCardProps = {
  cardBrand?: string | null;
  cardSummary?: string | null;
  expiryMonth?: number | null;
  expiryYear?: number | null;
  isDefault?: boolean;
  rightComponent?: React.ReactNode;
  flattened?: boolean;
};

export const PaymentMethodCard = ({
  cardBrand,
  cardSummary,
  expiryMonth,
  expiryYear,
  isDefault,
  rightComponent,
  flattened = false,
}: PaymentMethodCardProps) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="spaceBetween"
      className={clsx(styles.cardInfo, flattened && styles.noBorder)}
      width="full"
    >
      <Stack
        direction={flattened ? 'row' : 'column'}
        gap={flattened ? 'm' : undefined}
        alignItems={flattened ? 'center' : undefined}
      >
        <span className={styles.cardNumber}>
          {getCardBrandIcon(cardBrand)} **** {cardSummary}
        </span>
        {expiryMonth != null && expiryYear != null && (
          <span className={styles.cardExpiry}>
            <Content id={ContentId.Expires} /> {expiryMonth}/{expiryYear}
          </span>
        )}
      </Stack>
      <Stack alignItems="center" gap="m">
        {isDefault && (
          <span className={styles.cardBadge}>
            <Content id={ContentId.Default} />
          </span>
        )}
        {rightComponent}
      </Stack>
    </Stack>
  );
};
